import { ref, Ref, reactive, computed, toRaw } from 'vue'
import { getExchange } from '@/apis/shopcart'
import { useStore } from 'vuex'
import { t } from '@/plugins/i18n'

const deduplication = (arr: any, key: string) => {
  const map = new Map()
  for (const t of arr) {
    if (!map.has(t[key])) {
      map.set(t[key], t)
    }
  }
  return [...map.values()]
}

interface C {
  cateNameJp: string
  productCategoryFrontendId: string | number
}
export default () => {
  const rate = ref() // 汇率
  getExchange().then((res) => {
    rate.value = res.data.exchangeRate + 1
  })

  const store = useStore()
  const shopname = computed(() => store.getters.shopname)
  const buss = reactive(store.state.bussiness)
  const model = reactive({
    ...store.getters['bussiness/model'],
    channel: '',
    productCategoryFrontendId: ''
  })
  const sellPrice = computed({
    get: () => {
      if (model.sellPriceStart || model.sellPriceEnd) {
        return model.sellPriceStart + ',' + model.sellPriceEnd
      } else {
        return ''
      }
    },
    set: (v) => {
      if (v.includes(',')) {
        const sellPriceList = v.split(',')
        model.sellPriceStart = sellPriceList[0]
        model.sellPriceEnd = sellPriceList[1]
      } else {
        model.sellPriceStart = ''
        model.sellPriceEnd = ''
      }
    }
  })

  const cates: Ref<C[]> = ref([
    {
      cateNameJp: t('全部类目'),
      productCategoryFrontendId: ''
    }
  ])
  buss.promise.then(() => {
    cates.value = buss.category[buss.channel || '0']
  })

  const keyword = ref()
  const purchaseChannel: any = ref('')
  const isCommonProduct: any = computed(() => !(['3', '4'].includes(purchaseChannel.value)))
  const isOemProduct: any = computed(() => purchaseChannel.value === '3')
  const isCombinationProduct: any = computed(() => purchaseChannel.value === '4')

  const shopProduct = ref()

  // '3',
  const disabledModel = computed(() => ['5'].includes(model.channel))
  // '3',
  const disabledCategoryModel = computed(() => ['3', '4', '5'].includes(model.channel))

  const thirdItemName = computed(() => t('店铺商品'))
  const productTitle = computed(() => {
    if (model.channel) {
      if (model.channel === '3') {
        return t('OEM商品')
      } else if (model.channel === '4') {
        return t('组合商品')
      } else if (model.channel === '5') {
        return t('收藏商品')
      }
      return t('采购商品')
    } else {
      if (purchaseChannel.value === '3') {
        return t('OEM商品')
      } else if (purchaseChannel.value === '4') {
        return t('组合商品')
      }
      return t('采购商品')
    }
  })

  return {
    rate,
    shopname,
    sellPrice,
    cates,
    keyword,
    purchaseChannel,
    isCommonProduct,
    isOemProduct,
    isCombinationProduct,
    shopProduct,
    model,
    disabledModel,
    disabledCategoryModel,
    thirdItemName,
    productTitle
  }
}
